export default "__VITE_ASSET__CgqfHafh__";